import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer border border-dark-subtle">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
          <img src="img/logoMartin.png" className="imgLogo" alt="Logo ElectroBazar Distribuciones"/>
            <p>
            Nos dedicamos a proporcionar a nuestros clientes una amplia gama de productos a precios competitivos. Ya sea a precio mayorista o minorista.
            </p>
          </div>
          <div className="col-md-4">
            <h3 className="text-warning">𝐂𝐨𝐧𝐭𝐚𝐜𝐭𝐨</h3>
            <ul className='listStyle ps-0'>
              <li><i class="fa-solid fa-location-dot"></i> Dirección: Salvador de Carril 1584</li>
              <li><i class="fa-solid fa-location-dot"></i> Dirección: 4 de Enero 6797</li>

              <li><i class="fa-brands fa-whatsapp"></i> Teléfono: (342) 4328416, Consultas por ventas personalizadas.</li>
              
              <li><i class="fa-brands fa-whatsapp"></i> Teléfono de Salvador de Carril: (342) 427-5255, Consultas por catalogo o precio de productos.</li>
              <li><i class="fa-brands fa-whatsapp"></i> Teléfono de 4 de Enero: (342) 549-7573, Consultas por catalogo o precio de productos.</li>
              <li><i class="fa-sharp fa-solid fa-envelope"></i> Email: electrobazar67@gmail.com</li>
              <li><i class="fa-sharp fa-solid fa-clock"></i> Atención Comercial: Lunes a Jueves de 9:00 a 13:00 y de 16:00 a 20:00, y los Viernes de 9:00 a 17:00.</li>
            </ul>
          </div>
          <div className="col-md-4">
            <h3 className="text-warning">𝐌𝐚𝐬 𝐢𝐧𝐟𝐨𝐫𝐦𝐚𝐜𝐢𝐨𝐧</h3>
            <ul className="social-icons my-list more-info ps-0">
              <li>
                <Link to="/about">
                  Nosotros
                </Link>
              </li>
              <li>
                <Link to="/comocomprar">
                  ¿Como Comprar?
                </Link>
              </li>
              <li>
                <Link to="/contacto">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-12">
            <p className="text-center">
              © 2024 ElectroBazar. Todos los derechos reservados. Desarrollado por <Link to="https://www.linkedin.com/in/julian-cristian-mendoza-165a00202/" target="_blank">Julian C. Mendoza </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
